import { render, staticRenderFns } from "./examinationReport.vue?vue&type=template&id=3c31c9c4&"
import script from "./examinationReport.vue?vue&type=script&lang=js&"
export * from "./examinationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports